// extracted by mini-css-extract-plugin
export default {"profile-header-section":"ProfileHeaderSection_profile-header-section__xEfxn"};